(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GaiaConvey", [], factory);
	else if(typeof exports === 'object')
		exports["GaiaConvey"] = factory();
	else
		root["GaiaConvey"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 